import { render, staticRenderFns } from "./ClientVouchers.vue?vue&type=template&id=7f3a499e"
import script from "./ClientVouchers.vue?vue&type=script&lang=js"
export * from "./ClientVouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports